/** @format */

import {Trans} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {ColumnType} from 'components/Table/core/types';

import EmployeesCell from '../components/EmployeesCell';
import HeaderCell from '../components/HeaderCell';
import ResolvedCell, {ResolvedCellData} from '../components/ResolvedCell';
import SensorNameCell from '../components/SensorNameCell';

const Empty = () => <Box />;

export const summaryColumns: ColumnType[] = [
  {
    id: 'company',
    title: <Trans>Проект</Trans>,
    size: 200,
    sortingFn: 'text',
    order: 0,
    cell: info => <Typography>{String(info.getValue() ?? '')}</Typography>,
  },
  {
    id: 'staff',
    title: <Trans>Сотрудники</Trans>,
    size: 200,
    sortingFn: 'alphanumeric',
    order: 10,
    cell: info =>
      info.row.depth > 0 ? (
        <Empty />
      ) : (
        <EmployeesCell
          names={(info.row.original as {staffNames?: string[]}).staffNames ?? []}
          isExpanded={info.row.getIsExpanded()}
        />
      ),
  },
  {
    id: 'sensors',
    title: <Trans>Сработавшие сенсоры</Trans>,
    size: 400,
    sortingFn: 'alphanumeric',
    order: 20,
    cell: info =>
      info.row.depth > 0 ? (
        <SensorNameCell
          name={String(info.getValue() ?? '')}
          hasExceptions={Boolean((info.row.original as {hasExceptions?: boolean}).hasExceptions)}
        />
      ) : (
        <Typography>{String(info.getValue() ?? '')}</Typography>
      ),
  },
  {
    id: 'found',
    title: <Trans>Срабатывания</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    sortUndefined: 'last',
    order: 30,
    cell: info => <Typography>{String(info.getValue() ?? '')}</Typography>,
  },
  {
    id: 'fixed',
    title: <Trans>Исправления</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    sortUndefined: 'last',
    order: 40,
    cell: info => <Typography>{String(info.getValue() ?? '')}</Typography>,
  },
  {
    id: 'fixedPercent',
    title: <Trans>% исправлений</Trans>,
    size: 250,
    sortingFn: 'alphanumeric',
    sortUndefined: 'last',
    order: 50,
    cell: info => {
      const value = info.getValue();
      return <Typography>{value === '' || value == null ? '' : `${value}%`}</Typography>;
    },
  },
  {
    id: 'resolved',
    title: (
      <Box component='span' sx={{display: 'block', textAlign: 'center'}}>
        <Trans>Время исправления, дней</Trans>
      </Box>
    ),
    order: 60,
    children: [
      {
        id: 'resolvedAvg',
        title: (
          <HeaderCell
            title={<Trans>Среднее</Trans>}
            description={
              <Trans>
                Среднее время исправления срабатываний по сенсорам с момента возникновения (в днях)
              </Trans>
            }
          />
        ),
        size: 200,
        sortingFn: 'alphanumeric',
        sortUndefined: 'last',
        cell: info => (
          <ResolvedCell
            {...(info.row.original as unknown as {avgCell: ResolvedCellData}).avgCell}
          />
        ),
      },
      {
        id: 'resolvedMin',
        title: (
          <HeaderCell
            title={<Trans>Мин</Trans>}
            description={
              <Trans>
                Минимальное время исправления срабатываний по сенсорам с момента возникновения (в
                днях)
              </Trans>
            }
          />
        ),
        size: 200,
        sortingFn: 'alphanumeric',
        sortUndefined: 'last',
        cell: info => (
          <ResolvedCell
            {...(info.row.original as unknown as {minCell: ResolvedCellData}).minCell}
          />
        ),
      },
      {
        id: 'resolvedMax',
        title: (
          <HeaderCell
            title={<Trans>Макс</Trans>}
            description={
              <Trans>
                Максимальное время исправления срабатываний по сенсорам с момента возникновения (в
                днях)
              </Trans>
            }
          />
        ),
        size: 200,
        sortingFn: 'alphanumeric',
        sortUndefined: 'last',
        cell: info => (
          <ResolvedCell
            {...(info.row.original as unknown as {maxCell: ResolvedCellData}).maxCell}
          />
        ),
      },
    ],
  },
];
